import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvelopeReminderService {

  private _CONTROLLER = 'envelopereminder';

  constructor(private http: HttpClient) {
  }

  OnInit() {

  }

  public resendMail(envelopeSignatoryId: any): Observable<any> {
    return this.http.post(this._CONTROLLER.concat('/').concat(envelopeSignatoryId), {});
  }

  public resendWhatsApp(envelopeSignatoryId: any): Observable<any> {
    return this.http.post(this._CONTROLLER.concat('/SendReminderWhatsApp/').concat(envelopeSignatoryId), {})
  }
}
